import React from "react";

const items = [
  {
    title: "Համաձայնություն Օգտագործման Պայմաններին",
    description: `Մուտք գործելով և օգտագործելով ardarhay.am (այսուհետ՝ «Կայք»),
                  դուք ընդունում եք և համաձայնվում եք ստորև ներկայացված օգտագործման պայմաններին:
                  Եթե դուք չեք համաձայնվում այս պայմանների հետ, խնդրում ենք դադարեցնել Կայքի օգտագործումը:`,
  },
  {
    title: "Օգտագործման Պայմանների Փոփոխություններ",
    description: `ardahay.am-ը իրավունք է վերապահում ցանկացած պահի փոփոխել կամ թարմացնել այս պայմանները:
                  Փոփոխությունները կամ թարմացումները ուժի մեջ կմտնեն հրապարակման պահից:
                  Ձեր շարունակական օգտագործումը կհամարվի որպես համաձայնություն նոր փոփոխություններին:`,
  },
  {
    title: "Կայքի Բովանդակության Օգտագործումը",
    description: `Կայքի բոլոր բովանդակությունները, ներառյալ՝ հոդվածներ, վերլուծություններ, հատուկ թողարկումներ, միջոցառումներ,
                  տեսանյութեր և լուսանկարներ (այսուհետ՝ «Բովանդակություն»), պաշտպանված են հեղինակային իրավունքով:
                  Դուք իրավունք չունեք վերարտադրել, տարածել, փոփոխել կամ օգտագործել Բովանդակությունը առանց նախապես ստացված գրավոր թույլտվության ardarhay.am-ի կողմից:`,
    subItems: [
      `Անձնական օգտագործում: Բովանդակությունը կարող է օգտագործվել միայն անձնական և ոչ առևտրային նպատակներով:`,
      `Հրապարակում: Կայքի Բովանդակության ցանկացած առցանց կամ տպագիր հրապարակում պետք է ուղեկցվի ակտիվ հղումով դեպի ardarhay.am:`,
    ],
  },
  {
    title: "Օգտագործողի Պարտավորությունները",
    description: `Օգտագործելով Կայքը, դուք պարտավորվում եք.`,
    subItems: [
      `Չխախտել գործող օրենսդրությունը և Կայքի օգտագործման պայմանները:`,
      `Չփորձել մուտք գործել Կայքի համակարգեր կամ տեղեկատվություն չարտոնված ճանապարհով:`,
      `Չտարածել վիրուսներ, չարամիտ ծրագրեր կամ այլ տեխնոլոգիաներ, որոնք կարող են վնասել Կայքի աշխատանքը:`,
    ],
  },
  {
    title: "Գրանցում և Անվտանգություն",
    description: `Որոշ ծառայություններ կամ հնարավորություններ կարող են հասանելի լինել միայն գրանցված օգտատերերին: 
                  Դուք պատասխանատու եք ձեր մուտքի տվյալների գաղտնիության պահպանման համար: 
                  Եթե նկատում եք ձեր հաշվի չարտոնված օգտագործում, խնդրում ենք անհապաղ տեղեկացնել մեզ:`,
  },
  {
    title: "Երրորդ Կողմի Հղումներ",
    description: `Կայքում կարող են ընդգրկվել հղումներ դեպի երրորդ կողմի կայքեր կամ ծառայություններ:
                  Մենք պատասխանատվություն չենք կրում այդ կայքերի բովանդակության, գաղտնիության քաղաքականության կամ անվտանգության համար:
                  Խորհուրդ ենք տալիս ծանոթանալ այդ կայքերի պայմաններին նախքան դրանք օգտագործելը:`,
  },
  {
    title: "Գովազդ և Հրապարակումներ",
    description: `ardahay.am-ը կարող է համագործակցել գովազդատուների և գործընկերների հետ:
                  Կայքում տեղադրված գովազդները և հրապարակումները չեն երաշխավորում կամ հաստատում կայքի բովանդակությունը,
                  և մենք պատասխանատվություն չենք կրում նրանց կողմից տրամադրված ծառայությունների համար:`,
  },
  {
    title: "Հրաժարում Պատասխանատվությունից",
    description: `ardahay.am-ը չի երաշխավորում Կայքի բովանդակության ճշտությունը, ամբողջականությունը կամ հուսալիությունը:
                  Կայքի բովանդակությունը տրամադրվում է "ինչպես կա" սկզբունքով՝ առանց որևէ տեսակի երաշխիքների:
                  Օգտագործելով Կայքը, դուք համաձայնվում եք, որ ardarhay.am-ը պատասխանատվություն չի կրում
                  Կայքի օգտագործման արդյունքում առաջացած որևէ վնասի կամ կորուստի համար:`,
  },
  {
    title: "Հակամարտությունների Կարգավորում",
    description: `Այս պայմանները կառավարվում են Հայաստանի Հանրապետության օրենսդրությամբ:
                  Բոլոր վեճերը կամ հակամարտությունները, որոնք ծագում են Կայքի օգտագործման հետ կապված,
                  կլուծվեն դատական կարգով ՀՀ համապատասխան դատարաններում:`,
  },
];

const Programs = () => {
  return (
    <div className="my-36 px-10 md:px-20">
      <span className="font-bold text-[24px]">Օգտագործման Պայմաններ</span>
      {items.map((item, index) => {
        return (
          <div key={index} className="mt-8">
            <span className="font-bold text-[18px]">
              {index + 1}. {item.title}
            </span>
            <p className="mt-2">{item.description}</p>
            <ul className="mt-2 list-disc list-inside">
              {item.subItems?.map((subItem, index) => {
                return <li key={index}>{subItem}</li>;
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default Programs;
